import { ChangeEvent, FC, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import Text from '@components/common/text';
import { useCreatePassReviewPostComments, usePassReviewPostComments } from '@repository/passReview/usePassReview';
import { useLoginModal } from '@components/loginModal/LoginModalContext';
import Item from './Item';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Props {
  openCommentDeleteModal: (sn: number) => void;
}

const Comment: FC<Props> = ({ openCommentDeleteModal }) => {
  const { query } = useRouter();
  const ref = useRef<HTMLTextAreaElement>(null);
  const [myComment, setMyComment] = useState('');
  const { data: commentsData, refetch } = usePassReviewPostComments(Number(query.sn));
  const { mutateAsync: createComment } = useCreatePassReviewPostComments();
  const { isLogin, openLoginModal } = useLoginModal();

  const onClickComment = () => {
    if (!isLogin) openLoginModal();
  };

  const onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    handleResizeHeight();
    setMyComment(event.target.value);
  };

  const handleResizeHeight = () => {
    if (!ref.current) return;

    const target = ref.current;
    target.style.height = '0';
    target.style.height = `${target.scrollHeight}px`;
  };

  const handleRegisterBtn = async () => {
    await createComment(
      { sn: Number(query.sn), comment: myComment },
      {
        onSuccess: () => {
          setMyComment('');
          refetch();
          if (ref.current) ref.current.style.height = '0';
        },
      },
    );
  };

  if (!commentsData) return null;

  const itemEls = commentsData.posts.map((item) => {
    return <Item key={item.commentSn} data={item} openCommentDeleteModal={openCommentDeleteModal} />;
  });

  return (
    <>
      <div>
        <Text fontStyle={FontStyle.B1P_B}>
          댓글
          <span className={cx('length')}>{commentsData.posts.length}</span>
        </Text>

        <div className={cx('itemArea')}>{itemEls}</div>

        <div className={cx('commentArea')}>
          <div style={{ height: ref.current?.scrollHeight, minHeight: 98 }}>
            <textarea
              ref={ref}
              placeholder={'합격 후기에 응원과 공감을 더해 주세요.'}
              maxLength={300}
              value={myComment}
              onFocus={onClickComment}
              onChange={onChange}
              style={{ minHeight: 98 }}
            />
          </div>

          <div className={cx('register')}>
            <Text
              fontStyle={FontStyle.B4_M}
              color={Colors.C_COOL_GRAY_70}
            >{`최대 글자수 : ${myComment.length} / 300`}</Text>
            <button className={cx('btn')} disabled={!myComment.length} onClick={handleRegisterBtn}>
              등록
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Comment;
